import React, { useState } from "react";
import { Form, Button, Row, Col, FloatingLabel } from "react-bootstrap";
import { RiUpload2Fill } from "react-icons/ri";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";



const CreateEvent = () => {
  const [eventTitle, setEventTitle] = useState("");
  const [editorData, setEditorData] = useState("");
  const [eventDescription, setEventDescription] = useState(""); // ✅ Keep event description
  const [eventDate, setEventDate] = useState({ month: "", day: "", year: "", time: "" });
  const [numSeats, setNumSeats] = useState("");
  const [ticketPrice, setTicketPrice] = useState("");
  const [dobDay, setDobDay] = useState('10'); // Default day
  const [errors, setErrors] = useState({});
  const [dobMonth, setDobMonth] = useState('9'); // Default month
  const [dobYear, setDobYear] = useState('2000'); // Default year
  const [images, setImages] = useState([]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate form fields
    const newErrors = {};

    if (!eventTitle) {
      newErrors.eventTitle = 'Event Title is required.';
    }

    if (!eventDescription || eventDescription.trim() === "" || eventDescription === "<p><br></p>") {
      newErrors.eventDescription = "Event description is required.";
    }

    if (!dobDay || !dobMonth || !dobYear || !eventDate) {
      newErrors.dtm = 'Please select a valid date and time of event.';
    }

    if (!numSeats) {
      newErrors.numSeats = 'Number Of Seats is required.';
    }

    if (!ticketPrice) {
      newErrors.ticketPrice = 'Ticket Price is required.';
    }

    // Update errors state
    setErrors(newErrors);

    // ✅ Stop submission if there are errors
    if (Object.keys(newErrors).length > 0) {
      return;
    }

  };

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const newImages = selectedFiles.map((file) => ({
      id: URL.createObjectURL(file), // Temporary URL for preview
      file,
    }));
    setImages((prevImages) => [...prevImages, ...newImages]);
  };

  const removeImage = (id) => {
    setImages(images.filter((image) => image.id !== id));
  };

  const resetForm = () => {
    setEventTitle('');
    setImages('');
    setDobDay('');
    setDobMonth('');
    setDobYear('');
    setDobYear('');
    setEventDate('');
    setNumSeats('');
    setTicketPrice(''); // Reset country code
  };


  return (
    <div className="create-event-container">
      <h3 className="mb-3">Create an Event</h3>

      <Form onSubmit={handleSubmit}>
        <div className="mb-3">
          {/* Event Title */}
          <FloatingLabel controlId="eventTitle" label="Event Title">
            <Form.Control
              type="text"
              placeholder="Event Title"
              value={eventTitle}
              onChange={(e) => setEventTitle(e.target.value)}
              className={errors.eventTitle ? 'is-invalid' : ''}
            />
          </FloatingLabel>
          {errors.eventTitle && <div className="text-danger mt-1">{errors.eventTitle}</div>} {/* ✅ eventTitle error message */}
        </div>


        {/* Event Description */}
        <div className="mb-3">
          <div className={`custom-editor ${errors.eventDescription ? "is-invalid" : ""}`}>
            <CKEditor
              editor={ClassicEditor}
              className={errors.eventDescription ? 'is-invalid' : ''}
              data={eventDescription} // ✅ Use `eventDescription`
              onChange={(event, editor) => {
                const data = editor.getData();
                setEditorData(data);
                setEventDescription(data); // ✅ Keep `eventDescription` updated
              }}
            />
          </div>
          {errors.eventDescription && <div className="text-danger mt-1">{errors.eventDescription}</div>}
        </div>

        {/* Upload Event Banner */}
        <div className="upload-section mb-3">
          <label className="upload-box">
            <RiUpload2Fill className="upload-icon" />
            {images.length === 0 ? "Upload event banner (Size 1200 x 778)" : "Add more images"}
            <input type="file" accept="image/*" multiple hidden onChange={handleFileChange} />
          </label>

          {/* Preview Section */}
          {images.length > 0 && (
            <div className="image-preview-container">
              {images.map((image) => (
                <div key={image.id} className="image-preview">
                  <img src={image.id} alt="Uploaded" className="preview-img" />
                  {/* <Button variant="danger" size="sm" className="remove-btn" onClick={() => removeImage(image.id)}>
                  ×
                  </Button> */}
                  <span className="remove-btn" onClick={() => removeImage(image.id)}>×</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Date & Time Selection */}
        <Row className="mb-3 gx-2">
          <Col md={3}>
            <FloatingLabel controlId="floatingDay" label="Day">
              <Form.Select
                aria-label="Day"
                value={dobDay}
                onChange={(e) => setDobDay(e.target.value)}
                className={errors.dtm ? 'is-invalid' : ''}
              >
                <option value="">Day</option>
                {[...Array(31)].map((_, i) => (
                  <option key={i} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </Col>
          <Col md={3}>
            <FloatingLabel controlId="floatingMonth" label="Month">
              <Form.Select
                aria-label="Month"
                value={dobMonth}
                onChange={(e) => setDobMonth(e.target.value)}
                className={errors.dtm ? 'is-invalid' : ''}
              >
                <option value="">Month</option>
                {[...Array(12)].map((_, i) => (
                  <option key={i} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </Col>
          <Col md={3}>
            <FloatingLabel controlId="floatingYear" label="Year">
              <Form.Select
                aria-label="Year"
                value={dobYear}
                onChange={(e) => setDobYear(e.target.value)}
                className={errors.dtm ? 'is-invalid' : ''}
              >
                <option value="">Year</option>
                {[...Array(100)].map((_, i) => (
                  <option key={i} value={2022 - i}>
                    {2022 - i}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </Col>
          <Col md={3}>
            <FloatingLabel controlId="floatingTime" label="Time">
              <Form.Control
                type="time"
                className={errors.dtm ? 'is-invalid' : ''}
                onFocus={(e) => e.target.showPicker && e.target.showPicker()} // Opens time picker when clicking anywhere
                onChange={(e) => setEventDate({ ...eventDate, time: e.target.value })}
              />
            </FloatingLabel>
          </Col>
          {errors.dtm && <div className="text-danger mt-1">{errors.dtm}</div>} {/* ✅ dtm error message */}
        </Row>

        {/* Number of Seats & Ticket Price */}
        <Row className="mb-3 gx-2">
          <Col md={6}>
            <FloatingLabel controlId="floatingSeats" label="No of Seats">
              <Form.Select
                value={numSeats}
                className={errors.numSeats ? 'is-invalid' : ''}
                onChange={(e) => setNumSeats(e.target.value)}
              >
                <option value="">No of Seats</option>
                {[...Array(50)].map((_, index) => (
                  <option key={index + 1} value={index + 1}>
                    {index + 1}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
            {errors.numSeats && <div className="text-danger mt-1">{errors.numSeats}</div>} {/* ✅ numSeats error message */}
          </Col>
          <Col md={6}>
            <FloatingLabel controlId="floatingPrice" label="Price of Ticket">
              <Form.Control
                type="number"
                placeholder="Price of Ticket"
                value={ticketPrice}
                className={errors.ticketPrice ? 'is-invalid' : ''}
                onChange={(e) => setTicketPrice(e.target.value)}
                step="0.01" // Allows decimals (e.g., 20.55)
                min="0" // Prevents negative values
              />
            </FloatingLabel>
            {errors.ticketPrice && <div className="text-danger mt-1">{errors.ticketPrice}</div>} {/* ✅ ticketPrice error message */}
          </Col>
        </Row>

        {/* Buttons */}
        {/* <div className="event-buttons mt-4">
          <Button variant="danger" size="lg">Create Event</Button>
          <Button variant="link" className="discard-btn">Discard</Button>
        </div> */}
        <div className="form-buttons">
          <Button type="submit" size="lg" className="btn btn-primary">Create Event</Button>
          <Button variant="link" onClick={resetForm}>Discard</Button>
        </div>
      </Form>
    </div>
  );
};

export default CreateEvent;
